export enum TicketSourceType {
  MESSAGE = "message",
  COMMENT = "comment",
}
